module.exports = __webpack_public_path__ + "img/bf4333b.jpg";